import { render } from "./InputNumber.vue?vue&type=template&id=277c4ca6&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=277c4ca6&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277c4ca6"]])

export default __exports__